/**
 * AffiliateSidebarCrest — Sits at top of the left nav card on desktop.
 * Logo + "Você está jogando com" label + affiliate name + 2px divider.
 * Renders nothing on mobile or when storefront is null.
 */
import React, { useContext } from 'react';
import Contexts from '../../contexts/Contexts';

const AffiliateSidebarCrest: React.FC = () => {
  const { storefront, screenSize } = useContext(Contexts);
  if (!storefront || !screenSize.isDesktop) return null;

  return (
    <div style={{ padding: '12px 12px 0 12px' }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        marginBottom: 8,
      }}>
        {storefront.logo_url && (
          <img
            src={storefront.logo_url}
            alt={storefront.display_name}
            style={{ height: 24, maxWidth: 72, objectFit: 'contain', flexShrink: 0 }}
          />
        )}
        <div style={{ minWidth: 0 }}>
          <div style={{ fontSize: 10, color: '#9aa9b3', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, lineHeight: 1 }}>
            Você está jogando com
          </div>
          <div style={{ fontSize: 13, fontWeight: 800, color: '#1a2a36', lineHeight: 1.2, marginTop: 2, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {storefront.display_name}
          </div>
        </div>
      </div>
      <div style={{ height: 2, background: storefront.primary_color, borderRadius: 99, marginBottom: 4 }} />
    </div>
  );
};

export default AffiliateSidebarCrest;
